// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"585":"MainLayout","756":"AuthLayout"}[chunkId] || chunkId) + "-legacy." + {"33":"1a45f42f","100":"77a9c8eb","156":"c2b228e9","349":"f188cae1","456":"6c71b44b","490":"f43657da","565":"ab04df9d","585":"d1f5deb3","745":"3e299c99","756":"f445afb7"}[chunkId] + ".js";
};